import React from "react";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import BarChartIcon from "@material-ui/icons/BarChart";
import { SIAAConnectIcon } from "../components/Header/Icons";

const SIAA_CONNECT_REDIRECT = process.env.REACT_APP_SIAA_CONNECT_REDIRECT;
const FINANCIAL_REDIRECT = process.env.REACT_APP_FINANCIAL_REDIRECT;
const REMITTANCE_REDIRECT = process.env.REACT_APP_REMITTANCE_REDIRECT;

export const headerConfigKeys = {
  SIAA_CONNECT: "siaaConnect",
  FINANCIAL: "financial",
  REMITTANCE: "remittance",
};

export const onboardingHeaderConfig = [
  {
    key: headerConfigKeys.FINANCIAL,
    displayName: "Financials",
    redirectTo: FINANCIAL_REDIRECT,
    newTab: false,
    sameDomain: true,
    icon: <BarChartIcon />,
  },
  {
    key: headerConfigKeys.REMITTANCE,
    displayName: "Remittance",
    redirectTo: REMITTANCE_REDIRECT,
    newTab: true,
    sameDomain: false,
    icon: <AttachMoneyIcon />,
  },
  {
    key: headerConfigKeys.SIAA_CONNECT,
    displayName: "SIAA Connect",
    redirectTo: SIAA_CONNECT_REDIRECT,
    newTab: false,
    sameDomain: false,
    icon: <SIAAConnectIcon />,
  },
];
